import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';
import { IProductDataV3 } from '@df/catalog/product/product';
import { ICmsComponent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { ReviewsIOCarouselComponent } from 'projects/app-default/src/app/module/reviews-io/components/reviews-io-carousel.component';
import { Product } from '../../product.decorator';
import { AbstractProductCmsComponent } from '../abstract-product-cms.component';
export namespace NCmsProductReviews {
    export interface IComponentData extends NICmsContentComponent.IData {
        title?: string;
    }
}
@Component({
    selector: 'cms-product-reviews',
    templateUrl: './cms-product-reviews.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule, ReviewsIOCarouselComponent]
})
@ICmsComponent<CmsProductReviewsComponent>({
    id: 'product-reviews',
    name: 'Product reviews',
    tags: ['product page', 'reviews'],
    onDemandOnly: true,
    fields: [
        <NICmsContentField.IField>{
            key: 'title',
            type: NICmsContentField.EFieldType.text,
            title: 'Section Title'
        }
    ]
})
export class CmsProductReviewsComponent extends AbstractProductCmsComponent<NCmsProductReviews.IComponentData> {
    canShow = false;
    // Used to hide component includding top/bottom paddings/margins.
    @HostBinding('style.display')
    styleDisplay = 'none';

    source?: Product<IProductDataV3>;

    override ngOnInit(): void {
        this.onProductUpdate();
        this.subscriptions.add(this.productViewLayoutComponent.productView.modelChange.subscribe(() => this.onProductUpdate()));
        super.ngOnInit();
    }
    onProductUpdate(): void {
        this.canShow = this.product.canDisplayReviews;
        this.styleDisplay = this.canShow ? 'block' : 'none';
        this.detectChanges();
    }
}
